.tickDaysStyle > svg > text {
  font-size: 18px;
  fill: var(--tractie-color-content-emphasis);
  transform: translate(65px, -16px);
}

.tickHoursStyle > svg > text {
  font-size: 14px;
  fill: var(--tractie-color-content-default);
  background-color: var(--tractie-color-background-default);
}

.miniTickHoursStyle > svg > text {
  font-size: 12px;
  fill: var(--tractie-color-content-default);
  background-color: var(--tractie-color-background-default);
}
